import parseValue from './parse-value';

export default (value, units) =>
  [parseValue(value), units].filter(Boolean).join(' ');
